export default {
  hordeEnergyToStr: '每当前能量 +{0} 力量',
  hordeEnergyToEnergyReg: '每丢失能量 +{0} 能量再生',
  hordeEnergyOnCrit: '暴击时 +{0} 能量',
  hordeHealOnCrit: '暴击时治愈 {0} 最大生命值',
  hordeRestoreCooldownOnCrit: '暴击时减少冷却 {0}',
  hordeBloodOnCrit: '暴击时获得 {0} 敌人血液',
  hordeManaRest: '在不使用 {0} 的激活后获得 {1} 的法力回复',
  hordeManasteal: '击杀时获得 {0} 法力',
  hordePassiveRecovery: '每秒应用 {0} 恢复',
  hordeActiveDamageCrit: '伤害性活动可以在 {0} 效率下暴击',
  hordeActiveHealCrit: '治疗活动可以以 {0} 的效率暴击',
  hordeAttackAfterTime: '在同一场战斗中每分钟获得+{0}次攻击',
  hordeStrIntAfterTime: '在同一战斗中每分钟获得{0}力量和智力',
}
